import { Fragment, FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { CommonStyle, Loader } from "Components";
import PatientApi from "Service/Patient.api";
import NoData from "Components/NoData";
import { SideModalProps } from "DataTypes/Modal";
import { PatientInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { RedoxVitalType } from "DataTypes/Services/Patient.type";
import RedoxFormatter from "Utils/Redox.Formatter";
import DateTime from "Utils/DateTime";
import ImgPath from "Constant/Imgs";
import UpdateVital from "./UpdateVital";

export interface DataActionType {
  data: RedoxVitalType | null;
  action: "ADD" | "EDIT" | "VIEW" | "DELETE" | null;
}

const initailState: DataActionType = { data: null, action: null };

const Vital: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const crudPermission = myInfo.roleId != 6;
  const newPaitientId = patientInfo.id;
  const [vitalData, setVitalData] = useState<RedoxVitalType[]>([]);
  const [loading, setLoading] = useState(true);
  const [dataAction, setDataAction] =
    useState<DataActionType>(initailState);

  useEffect(() => {
    fetchVitals();
  }, []);

  const fetchVitals: () => void = async () => {
    setLoading(true);
    const res: any = await PatientApi.RedoxVitals({ id1: newPaitientId });
    if (res?.success) {
      setVitalData(RedoxFormatter.VitalList(res?.data?.vitals));
    } else setVitalData([]);
    setLoading(false);
  };

  const handleCloseLayer2: () => void = () => {
    setDataAction(initailState)
  };

  const Layer1Header = (
    <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
      <Typography fontWeight="bold">Vitals</Typography>
      <Box display={"flex"}>
        {crudPermission && (
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={() => setDataAction({ data: null, action: "ADD" })}
          >
            <ImgPath.PlusIcon titleAccess="Add Vital" />
          </Box>
        )}
        <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => {
            handleCloseLayer2();
            onClose();
          }}
        >
          <ImgPath.CloseIcon titleAccess="Close" />
        </Box>
      </Box>
    </Box>
  );

  const Layer1List = (
    vitalData.map((el) => {
      const newVal = [
        el?.value,
        el?.unit,
        el?.targetSitename,
        el?.interpretation,
      ].filter(Boolean).join(" ");
      return (
        <Fragment key={el.id}>
          <Box
            sx={{
              ...CommonStyle.sxRow,
              mb: 1.5,
              alignItems: "flex-start",
              "& >h6": { mr: 3 },
            }}
          >
            <Box flex={1}>
              <Typography variant="subtitle1">
                {el.name} - {newVal}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {DateTime.ToLocalDate(el.dateTime)}
              </Typography>
            </Box>
            {crudPermission && (
              <Box display="flex" sx={{ "&>div": { ml: 1 } }}>
                <Box
                  sx={{ ...CommonStyle.sxRoundIconsMainSm }}
                  onClick={() => setDataAction({ data: el, action: "EDIT" })}
                >
                  <ImgPath.EditOutlined />
                </Box>
                <Box
                  sx={{ ...CommonStyle.sxRoundIconsMainSm }}
                  onClick={() => setDataAction({ data: el, action: "DELETE" })}
                >
                  <ImgPath.DeleteOutline />
                </Box>
              </Box>
            )}
          </Box>
        </Fragment>
      );
    })
  );

  const Layer1 = (
    <Fragment>
      {Layer1Header}
      <Box sx={{ ...sxMain }}>
        {loading ? <Loader /> : vitalData.length ? Layer1List : <NoData />}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {dataAction.action && (
        <Box width="64%">
          <UpdateVital
            dataAction={dataAction}
            onClose={handleCloseLayer2}
            refreshList={fetchVitals}
          />
        </Box>
      )}
    </Fragment>
  );

};
export default Vital;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};
